const EXTENSION_MESSAGE_CHANNEL_SUBSTRINGS = [
  'message channel closed before a response was received',
  'message port closed before a response was received',
];

function extractUnhandledRejectionMessage(reason) {
  if (typeof reason === 'string') return reason;
  if (reason instanceof Error) return reason.message || String(reason);
  if (reason && typeof reason.message === 'string') return reason.message;
  if (reason == null) return '';
  try {
    return String(reason);
  } catch (_) {
    return '';
  }
}

export function shouldIgnoreUnhandledRejectionReason(reason) {
  const message = extractUnhandledRejectionMessage(reason).toLowerCase();
  if (!message) return false;
  return EXTENSION_MESSAGE_CHANNEL_SUBSTRINGS.some((needle) => message.includes(needle));
}

export function installIgnoredPromiseRejectionHandler() {
  if (typeof window === 'undefined') return;
  if (window.__CASTICART_IGNORED_REJECTION_HANDLER__) return;

  window.addEventListener('unhandledrejection', (event) => {
    if (!shouldIgnoreUnhandledRejectionReason(event?.reason)) return;
    event.preventDefault();
  });

  window.__CASTICART_IGNORED_REJECTION_HANDLER__ = true;
}
